import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { labelValuesShape, renderLabelBlob } from './labelPdf';

/**
 * Live label preview. Debounces form values so the PDF isn't regenerated on
 * every keystroke, then shows the rendered blob — the same one printing uses.
 */
export default function LabelPreview({ values, travelerId = null }) {
  const [debouncedValues, setDebouncedValues] = useState(values);
  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValues(values), 400);
    return () => clearTimeout(timer);
  }, [values]);

  const [previewUrl, setPreviewUrl] = useState(null);
  useEffect(() => {
    let cancelled = false;
    let url = null;
    renderLabelBlob(debouncedValues, travelerId)
      .then((blob) => {
        if (cancelled) return;
        url = URL.createObjectURL(blob);
        setPreviewUrl(url);
      })
      .catch(() => { if (!cancelled) setPreviewUrl(null); });
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [debouncedValues, travelerId]);

  return (
    // Sized close to the label's 2:1 aspect ratio; view=Fit makes the PDF
    // viewer scale the page to the box instead of its default zoom.
    <div
      style={{
        width: 202, height: 102, margin: '0 auto',
      }}
    >
      {previewUrl && (
        <iframe
          title="Label preview"
          src={`${previewUrl}#toolbar=0&navpanes=0`}
          width="100%"
          height="100%"
          style={{ border: 0 }}
        />
      )}
    </div>
  );
}

LabelPreview.propTypes = {
  values: labelValuesShape.isRequired,
  travelerId: PropTypes.string,
};
